<template>
	<div class="index-box" >
			<div class="block" >
				<block1 :isAnim='isAnim'></block1>
			</div>
		<BFooter></BFooter>
	</div>
</template>
<script>
	import Block1 from '@/components/block1'
	import BFooter from '../components/footer'
  import store from '@/store/store'
	export default {
		name:'Index',
		data() {
			return {
				//document.documentElement.clientHeight,
				curIndex:0,
				// imgArr1:[require('../assets/banner1-1.png'),require('../assets/banner1-2.png'),require('../assets/banner1-3.png')],
				// imgArr2:[require('../assets/banner2-1.png'),require('../assets/banner2-2.png'),require('../assets/banner2-3.png')],
				// imgArr3:[require('../assets/banner3-1.png'),require('../assets/banner3-2.png'),require('../assets/banner3-3.png')],
				isAnim:false,
				isAnimBlock2:false,
				isAnimBlock3:false,
				// isAnimBlock4:false,
				flagTime:true
			}
		},
		components:{
			Block1,BFooter
		},
		mounted(){
			const that = this;
			window.onresize = () =>{
				return (() => {
					that.$store.commit('setFullHeight',{height:document.documentElement.clientHeight});
				})()
			},
			(function(){
				if(document.addEventListener){
					document.addEventListener('DOMMouseScroll',that.getScrollHeight,false);
				}
				window.onmousewheel=document.onmousewheel=that.getScrollHeight;//IE/Opera/Chrome
			})();
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
	    if(flag) {
	      this.$router.replace('/mobilindex');
	    }
			// else{
	    //   this.$router.replace('/');
	    // }
		},
		created:function () {
			const that = this
			self.deployTimeOutId = setTimeout(() => {
				that.isAnim = true;
			}, 100);
			this.$store.commit('inWhichPage',{page:'isIndex'});
			this.$store.commit('setFullHeight',{height:document.documentElement.clientHeight});
      this.$store.commit('setInitParam',document);
		},
		computed:{
			fullHeight() {
				return this.$store.state.fullHeight;
			}
		},
		methods:{
			getScrollHeight:function (e) {
				const that = this
				if(this.flagTime){
					this.flagTime = false;
					if(this.curIndex==2&&(e.wheelDelta<0||e.detail<0)){
						this.curIndex=2
					}else if(this.curIndex==0&&(e.wheelDelta>0||e.detail>0)){
						this.curIndex=0
					}else{
						e.wheelDelta<0||e.detail<0?this.curIndex++:this.curIndex--;
					}
					if(this.curIndex==1){
						this.isAnimBlock2 = true;
						this.isAnimBlock3 = false;
					}else if (this.curIndex==2) {
						this.isAnimBlock2 = false;
						this.isAnimBlock3 = true;
						// this.isAnimBlock4 = false;
					}
					// else if (this.curIndex==3) {
					// 	this.isAnimBlock3 = false;
					// 	this.isAnimBlock4 = true;
					// }
					setTimeout(function () {
						that.flagTime = true;
					},500)
				}
			},
      clickDialogClose:function () {
        this.news = '';
      }
		},
		destoryed:function () {
			window.clearTimeout(this.deployTimeOutId);
		}
	}
</script>
<style>
	.index-box{
		overflow: hidden;
		width: 100%;
		transition: all .7s;
		background: url("../assets/bg.png") no-repeat fixed top;
		background-size: 100% 100%;
	}
	.block{
		/* background: #F54E31; */
		width:100%;
		height:100%;
	  display: inherit;
		overflow: hidden;
		position: relative;
	}


	.text-block{
		position: absolute;
		right: 5%;
		top: 52%;
		margin-top: -115px;
	}

	.text-content.index-content{
	  position: relative;
		margin-right: 0;
		opacity: 0;
	  transition: all 1s;
		height: 230px;
	}

	.text-content.index-content.anim{
		opacity: 1;
	}

	.text-content.index-content p{
	  color: #232323;
	  text-align: left;
		font-size: 18px;
		line-height: 40px;
	}

	.text-content.index-content p i{
	  opacity: 0.5;
	  font-size: 18px;
	  color: #232323;
	  letter-spacing: 0;
	}

	.text-content.index-content p:first-child{
		font-size: 46px;
		margin-bottom: 40px;
	  color: #232323;
		transition: all .6s;
	}


	.text-content.index-content p:not(:first-child){
		height: 40px;
		margin-top: 0;
		font-size: 16px;
	}

	@media (min-width: 1366px) {
		.text-content.index-content.anim{
			margin-right: 3%;
		}
		.text-content.index-content p{
			font-size: 20px;
		  line-height: 40px;
		}
		.text-content.index-content p:first-child{
		  font-size: 46px;
			margin-bottom: 40px;
		}
	}

	@media (min-width: 1440px) {
		.text-content.index-content.anim{
			margin-right: 0;
		}
		.text-content.index-content p{
			font-size: 20px;
    	line-height: 40px;
		}
		.text-content.index-content p:first-child{
		  font-size: 56px;
			margin-bottom: 40px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/index.vue